var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"for-rent-details fill-height transparent flex-fill d-flex justify-center"},[_c('HouseDetails',{attrs:{"header-panel":_vm.store.headerPanelForRent,"data":_vm.store.data.find(function (e) { return e.cod === this$1.$router.currentRoute.params.id; }),"store":_vm.store}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }